import { Grid, GridProps, Paper } from '@mui/material';

export default function InnerWithTabsContainer(props: GridProps) {
  return (
    <Paper>
      <Grid container {...props} />
    </Paper>
  );
}
